module.exports = __webpack_public_path__ + "static/opt_x2.5fab6bb0.png";